import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { saveEditorDraft as saveEditorDraftAction, removeEditorDraft as removeEditorDraftAction } from '../../DaEditorWrapper/redux/actionCreators';
import { useEditorDraftState } from './useEditorDraftState';
/** Returns functions that help manage editor drafts.  */ export function useEditorDraftActions(editorId) {
    const draftValue = useEditorDraftState(editorId);
    const dispatch = useDispatch();
    const saveEditorDraft = useCallback((state)=>{
        dispatch(saveEditorDraftAction(editorId, state));
    }, [
        dispatch,
        editorId
    ]);
    const removeEditorDraft = useCallback(()=>{
        if (draftValue) {
            dispatch(removeEditorDraftAction(editorId));
        }
    }, [
        dispatch,
        editorId,
        draftValue
    ]);
    return {
        /**
     * Saves the editor draft to redux and local storage.
     */ saveEditorDraft,
        /**
     * Removes the editor draft from redux and local storage.
     */ removeEditorDraft
    };
}

//# sourceMappingURL=useEditorDraftActions.js.map